import script from "./SettingsDatatableTDAnketaCategory.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDatatableTDAnketaCategory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__